import 'arrayq';
import { PureConnect, React } from '../react';
import { beheerEditor, beheerResource } from './resource';
import cx from './style.less';
import { IAdmin } from '../types';
import authmng from '../auth/selectors';
import { Btn } from '../react-toolbox-redesign/button';
import Toggle from '../react-toolbox-extended/toggle';
import ADMIN_CREATE from './actions/ADMIN_CREATE';
import ADMIN_UPDATE from './actions/ADMIN_UPDATE';
import { emptyState } from './reducer';
import { selectors as metaSelectors } from '../meta/selectors';
import { captionDeadlineAnsweringQuestion, captionDeadlineSendingQuestion, captionFactionFunctionality, captionTechnicalQuestionModule, tileTextDeadlineAnsweringQuestion, tileTextDeadlineSendingQuestion, tileTextFactionFunctionality, tileTextTechnicalQuestionModule } from './adminText';
import DEADLINE_QUESTIONS from './actions/DEADLINE_QUESTIONS';
import selectors from './selectors';

export default PureConnect(`AdminQuestion`)(
    (state) => ({
        item: state.beheer.item,
        busy: !!state.beheer.busy,
        deadlinedateenabled: selectors.deadlinedateenabled(state),
        deadlinedateanswerenabled: selectors.deadlinedateanswerenabled(state),
        documentId: metaSelectors.docId(state),
        accountmng: authmng.accountmanager(state),
        stat: state,
    }),
    (dispatch) => ({ 
        saveCreating: (item: IAdmin) => dispatch(ADMIN_CREATE({item: item, busy: true })),       
        saveUpdating: (item: IAdmin) => dispatch(ADMIN_UPDATE({item: item, busy: true })), 
        enableDeadlineDate:(sendingenabled: boolean, answerenabled: boolean) => dispatch(DEADLINE_QUESTIONS({sendingenabled: sendingenabled, answerenabled: answerenabled})),
    }),
    ({ item, documentId, deadlinedateenabled, deadlinedateanswerenabled, accountmng, busy, stat, enableDeadlineDate, saveCreating, saveUpdating }) => {

        const min2=-2;
        var on=item&&item.modquestion?item.modquestion:false;    

        function changeValue(nameField: string, val: any) {
            if (item) {
                item[nameField]=val;
                saveUpdating(item);
            } else {
                item=emptyState.item;
                item[nameField]=val;
                item.documentId = documentId;
                saveCreating(item);
            }
        }

        return (
            <div className={cx('container-question-module')}>
                <div className={cx('container-enable-question-module')}>
                    <div className={cx('content-container')}>
                        <div className={cx('header')}>                    
                            <div className={cx('contentheader')}>
                                <div className={cx('left-container-enable-question-module')}> 
                                    <div className={cx('text-container_author')}>
                                        <p id={`id-ref-enable-question-module`} className={cx('autho-name')}>                                  
                                            { captionTechnicalQuestionModule }                                    
                                        </p>  
                                    </div> 
                                </div>
                                <div className={cx('right-container')}>
                                    <Toggle  id={'toggle-1'} textLabel={on? 'Ingeschakeld': 'Uitgeschakeld'} isOn={on} handleToggle={() => { changeValue('modquestion', item?!item.modquestion:true);}} />
                                </div>
                                <div className={cx('left-sub-container')}>
                                    <p id={`id-ref-enable-question-module-descr`} className={cx('question-module-descr')}>
                                            { tileTextTechnicalQuestionModule }
                                    </p> 
                                </div>                        
                            </div>                 
                        </div>
                    </div>
                </div>
                
                <div className={cx('container-deadline-sending-question')}>
                    <div className={cx('content-container')}>
                        <div className={cx('header')}>                    
                            <div className={cx('contentheader')}>
                                <div className={cx('left-container-deadline-sending-question')}> 
                                    <div className={cx('text-container_author')}>
                                        <p id={`id-ref-deadline-sending-question`} className={cx('autho-name')}>                                  
                                            { captionDeadlineSendingQuestion }                                    
                                        </p>  
                                    </div> 
                                </div>
                                <div className={cx('right-container')}>
                                    <Btn
                                        type="button"
                                        className={'btn'} 
                                        extraClassNames={'secondary-btn'}
                                        aria-label={'Wijzig deadline insturen vragen'}
                                        aria-pressed={on}
                                        aria-expanded={on}
                                        aria-haspopup={false}
                                        tabIndex={0}
                                        onClick={() => { enableDeadlineDate(!deadlinedateanswerenabled, deadlinedateanswerenabled);}}
                                        disabled={!on || deadlinedateenabled}>
                                        <span>{'Wijzigen'}</span>
                                    </Btn>
                                </div>                                
                                <div className={cx('left-sub-container')}>
                                    <p id={`id-ref-deadline-sending-question-descr`} className={cx('deadline-question-descr')}>
                                            { tileTextDeadlineSendingQuestion }
                                    </p> 
                                </div>
                                <div className={cx('middle-sub-container')}>
                                    <div className={cx('datefield-deadline-question', deadlinedateenabled ? '': 'wcag-invisible')}>
                                            <input
                                                disabled={busy}
                                                id="date"
                                                className="form-control"
                                                type="date"
                                                lang="nl-NL"
                                                placeholder="dd-mm-yyyy"
                                                value={item&&item.deadlinequestion?
                                                    new Date(item.deadlinequestion).getFullYear() + '-' + 
                                                    ('0' + (new Date(item.deadlinequestion).getMonth() + 1)).slice(min2) + '-' + 
                                                    ('0' + new Date(item.deadlinequestion).getDate()).slice(min2): 'dd-mm-yyyy'
                                                }
                                                onChange={(e) => { 
                                                    changeValue('deadlinequestion', e.target.value);} }
                                            /> 
                                    </div>
                                    <div className={cx('datefield-deadline-question', !deadlinedateenabled ? '': 'wcag-invisible')}> 
                                                {item&&item.deadlinequestion ?  
                                                ('0' + new Date(item.deadlinequestion).getDate()).slice(min2) + '-' + 
                                                ('0' + (new Date(item.deadlinequestion).getMonth() + 1)).slice(min2) + '-' + 
                                                new Date(item.deadlinequestion).getFullYear() : 
                                                'dd-mm-yyyy'}
                                    </div>      
                                </div>                       
                            </div>                 
                        </div>
                    </div>
                </div> 

                <div className={cx('container-deadline-answering-question')}>
                    <div className={cx('content-container')}>
                        <div className={cx('header')}>                    
                            <div className={cx('contentheader')}>
                                <div className={cx('left-container-deadline-answering-question')}> 
                                    <div className={cx('text-container_author')}>
                                        <p id={`id-ref-deadline-answering-question`} className={cx('autho-name')}>                                  
                                            { captionDeadlineAnsweringQuestion }                                    
                                        </p>  
                                    </div> 
                                </div>
                                <div className={cx('right-container')}>
                                    <Btn
                                        type="button"
                                        className={'btn'} 
                                        extraClassNames={'secondary-btn'}
                                        aria-label={'Wijzig deadline beantwoorden vragen'}
                                        aria-pressed={on}
                                        aria-expanded={on}
                                        aria-haspopup={false}
                                        tabIndex={0}
                                        onClick={() => { enableDeadlineDate(deadlinedateanswerenabled, !deadlinedateanswerenabled);}}
                                        disabled={!on || deadlinedateanswerenabled}>
                                        <span>{'Instellen'}</span>
                                    </Btn>
                                </div>                                
                                <div className={cx('left-sub-container')}>
                                    <p id={`id-ref-deadline-answering-question-descr`} className={cx('deadline-question-descr')}>
                                            { tileTextDeadlineAnsweringQuestion }
                                    </p> 
                                </div>
                                <div className={cx('middle-sub-container')}>
                                    <div className={cx('datefield-deadline-question', deadlinedateanswerenabled ? '': 'wcag-invisible')}>
                                            <input
                                                disabled={busy}
                                                id="date"
                                                className="form-control"
                                                type="date"
                                                lang="nl-NL"
                                                placeholder="dd-mm-yyyy"
                                                value={item&&item.deadlineanswer?
                                                    new Date(item.deadlineanswer).getFullYear() + '-' + 
                                                    ('0' + (new Date(item.deadlineanswer).getMonth() + 1)).slice(min2) + '-' + 
                                                    ('0' + new Date(item.deadlineanswer).getDate()).slice(min2): 'dd-mm-yyyy'
                                                }
                                                onChange={(e) => {{ changeValue('deadlineanswer', e.target.value);} }}
                                            /> 
                                    </div>
                                    <div className={cx('datefield-deadline-question', !deadlinedateanswerenabled ? '': 'wcag-invisible')}> 
                                                {item&&item.deadlineanswer ?  
                                                ('0' + new Date(item.deadlineanswer).getDate()).slice(min2) + '-' + 
                                                ('0' + (new Date(item.deadlineanswer).getMonth() + 1)).slice(min2) + '-' + 
                                                new Date(item.deadlineanswer).getFullYear() : 
                                                'dd-mm-yyyy'}
                                    </div>  
                                </div>                       
                            </div>                 
                        </div>
                    </div>
                </div>

            </div>
        );
});

export const AdminQuestionFactionFunctionality = PureConnect(`AdminQuestionFactionFunctionality`)(
    (state) => ({
        item: state.beheer.item,
        busy: !!state.beheer.busy,
        documentId: metaSelectors.docId(state),
        accountmng: authmng.accountmanager(state),
        stat: state,
    }),
    (dispatch) => ({ 
        saveCreating: (item: IAdmin) => dispatch(ADMIN_CREATE({item: item, busy: true })),       
        saveUpdating: (item: IAdmin) => dispatch(ADMIN_UPDATE({item: item, busy: true })), 
        enableDeadlineDate:(sendingenabled: boolean, answerenabled: boolean) => dispatch(DEADLINE_QUESTIONS({sendingenabled: sendingenabled, answerenabled: answerenabled})),
    }),
    ({ item, documentId, accountmng, busy, saveCreating, saveUpdating }) => {

        var on=item&&item.factionvisible?item.factionvisible:false;    

        function changeValue(nameField: string, val: any) {
            if (item) {              
                item[nameField]=val;
                saveUpdating(item);
            } else {
                item=emptyState.item;
                item[nameField]=val;
                item.documentId = documentId;
                saveCreating(item);
            }
        }

        return (
            <div>
                <div className={cx('container-enable-faction-functionality')}>
                    <div className={cx('content-container')}>
                        <div className={cx('header')}>                    
                            <div className={cx('contentheader')}>
                                <div className={cx('left-container-enable-faction-functionality')}> 
                                    <div className={cx('text-container_author')}>
                                        <p id={`id-ref-enable-faction-functionality`} className={cx('autho-name')}>                                  
                                            { captionFactionFunctionality }                                    
                                        </p>  
                                    </div> 
                                </div>
                                <div className={cx('right-container')}>                                
                                    <Toggle id={'toggle-2'} textLabel={on? 'Ingeschakeld': 'Uitgeschakeld'} isOn={on} handleToggle={() => { changeValue('factionvisible', item?!item.factionvisible:true);}} />
                                </div>
                                <div className={cx('left-sub-container')}>
                                    <p id={`id-ref-enable-faction-functionality-descr`}>
                                            { tileTextFactionFunctionality }
                                    </p> 
                                </div>                        
                            </div>                 
                        </div>
                    </div>
                </div>

            </div>

        );
});



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/admin/questionsadmin.tsx